/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamConfigUpdateQuestionCount } from './oralExamConfigUpdateQuestionCount';
import type { OralExamConfigUpdateSecondsPerQuestion } from './oralExamConfigUpdateSecondsPerQuestion';

/**
 * Partial update for oral exam config (overrides only; pool managed via generate endpoint).
 */
export interface OralExamConfigUpdate {
  questionCount?: OralExamConfigUpdateQuestionCount;
  secondsPerQuestion?: OralExamConfigUpdateSecondsPerQuestion;
}
